import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Home.css";
import TopSearch from "../components/TopSearch";
import FoodSection from "../components/FoodSection";

const Home = () => {
  const [userSearch, setUserSearch] = useState("");
  const updateUserSearch = (newValue) => {
    setUserSearch(newValue);
  };

  return (
    <div>
      <Navbar />
      <TopSearch updateUserSearch={updateUserSearch} />
      <FoodSection userSearch={userSearch} />
      <Footer />
    </div>
  );
};

export default Home;
